import { required, optional, array, obj } from 'AppReact/schema';

const stats = {
  assigned: optional('integer'),
  completed: optional('integer'),
  callbacks: optional('integer'),
  completion_time: optional('number'),
  rating: optional('number'),
};

const monthStats = {
  rating: required('number'),
  completion_time: optional('number'),
};

export default {
  id: required('integer'),
  name: required('string'),
  email: required('string'),
  image: optional('string'),
  type: required('string'),
  category_ids: optional('array'),
  month_stats: obj(monthStats),
  phone_number: optional('string'),
  property_ids: array('integer'),
  stats: obj(stats),
  assignments: optional('number'),
};
